/* eslint-disable max-len */
/**
 * @file 内嵌页
 * @author gaoxunchen
 */

import React, { useEffect } from 'react';
import _ from 'lodash';
import { Route, Switch, HashRouter } from 'react-router-dom';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import commonReport from '@/common/common-report';
import { getUserId } from '@/api/operator/cgi/smb/common';

import Forbidden from '@/app/error/Forbidden';

dayjs.extend(duration);

import '@/assets/less/cm.less';

const routes = [
  {
    key: 'task-advertiser',
    href: '/task-advertiser',
    label: '任务指南',
    pageModule: ['策略'],
    component: loadable(() => import(/* webpackChunkName: 'task-advertiser' */ /* webpackMode: 'lazy' */ '@/pages/task-advertiser'), { fallback: <Loading /> }),
  },
  {
    key: 'payment-certification',
    href: '/payment-certification',
    label: '身份验证',
    pageModule: ['工具'],
    component: loadable(() => import(/* webpackChunkName: 'payment-certification' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/paymentCertification/embedded'), { fallback: <Loading /> }),
  },
  {
    key: 'user',
    href: '/user',
    label: '销售员工管理',
    pageModule: ['销售'],
    component: loadable(() => import(/* webpackChunkName: 'sysadmin' */ /* webpackMode: 'lazy' */ '@/pages/sale/oa/user'), { fallback: <Loading /> }),
  },
  {
    key: 'creative-component',
    href: '/creative/preview-detail',
    label: '组件预审',
    pageModule: ['投放', '创意组件预审'],
    component: loadable(() => import(/* webpackChunkName: 'creative-component' */ /* webpackMode: 'lazy' */ '@/pages/agency/creative-component/preview-detail/embedded'), { fallback: <Loading /> }),
  },
  {
    key: 'forbidden',
    href: '/',
    label: '无权限访问',
    component: Forbidden,
  },
];

export const EMBEDDED_PATH_MAP = routes.reduce((map: Record<string, string[]>, v: any) => ({
  ...map,
  [`/embedded.html#${v.href}`]: [...v.pageModule || [], v.label],
}), {});

const Content: React.FC = () => {
  return (
    <div id="main">
      <HashRouter>
        <Switch>
          {/* https://e.qq.com/ams/embedded.html#/task-advertiser */}
          {
            routes.map((v: any) => {
              return (
                <Route
                  key={v.href}
                  path={v.href}
                  component={v.component}
                />
              );
            })
          }
        </Switch>
      </HashRouter>
    </div>
  );
};

const Embedded: React.FC = () => {
  // 数据上报到reporthub
  useEffect(() => {
    getUserId().then((res) => {
      const { user_id = 0, login_type = 0 } = res?.data || {};
      commonReport.setLoginStatus({
        user_id,
        login_type,
        bm_id: 0,
        agency_uid: 0,
      });
    });
  }, []);

  return <Content />;
};

export default Embedded;
